<div class="wrapper">
  <div id="biChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #biChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>BI graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>